import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-components-specialist-actioncomponents-fileslegacy',
	templateUrl: './FilesLegacy.component.html'
})
export class FilesLegacyComponent {
    @Input() files: Boo.Objects.File[];
}
